import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/*
 * Os tamanhos de texto da casa (`text-selo`, `text-corpo`…) precisam ser
 * DECLARADOS aqui, senão o `twMerge` os lê como COR.
 *
 * Ele não conhece o tema: para `text-x` desconhecido o palpite é cor, e cor
 * conflita com cor — então `cn("text-primary-foreground", "text-selo")` devolvia
 * só `text-selo`, e a pastilha de não lidas ficava com a tinta escura da linha
 * sobre o fundo terracota. Vale para todo componente do registro que já traz
 * uma cor e recebe um tamanho nosso pelo `className`.
 */
/* As alturas (`h-padrao`, `min-h-toque`) e os raios (`rounded-controle`) da
   casa vão no TEMA pelo mesmo motivo: sem isso `cn("rounded-lg",
   "rounded-controle")` guardava as duas, e o raio que vale ficava por conta da
   ordem da folha. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ["mini", "padrao", "toque"],
      radius: ["etiqueta", "controle", "cartao", "superficie"],
      ease: ["entra", "sai", "mola", "movendo", "gaveta"],
    },
    classGroups: { "font-size": [{ text: ["selo", "apoio", "corpo", "forte", "titulo", "vista"] }] },
  },
});

/**
 * Junta classes e resolve o conflito entre elas.
 *
 * É a função que todo componente do shadcn chama. O nome fica em inglês (`cn`)
 * de propósito: é ela que os arquivos de `ui/` importam como vêm do registro, e
 * traduzir o nome aqui significaria reescrever a importação de sessenta
 * arquivos a cada `shadcn add`.
 *
 * O que ela resolve, e que `clsx` sozinho não resolve: `cn("p-2", "p-4")` devolve
 * `p-4`. Sem isso, passar `className="rounded-xl"` a um componente que já nasce
 * `rounded-lg` deixaria as duas classes na marcação e quem ganha seria a ordem
 * da folha — ou seja, sorte.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
